export const REPORT_01 = '1';
export const REPORT_02 = '2';
export const REPORT_03 = '3';
export const REPORT_04 = '4';
export const REPORT_05 = '5';
export const REPORT_06 = '6';
export const REPORT_07 = '7';
export const REPORT_Z01 = '1001';
export const REPORT_08 = '8';
export const REPORT_09 = '9';
export const REPORT_ST01 = '1002';
export const REPORT_ST02 = '1003';
export const REPORT_ST03 = '1004';
export const REPORT_ST04 = '1005';
export const VEHICLE_ENTITY = 'vehicle';
export const DRIVER_ENTITY = 'driver';
